<template>
  <div>
    <div class="header">
      <!-- <img class="logoimg" src="@/assets/images/bdlogo.png" /> -->
      <img class="logoimg" :src="logoImg" />
      <span id="title">{{ name }}</span>
      <el-dropdown class="userControlClass" trigger="click">
        <span class="el-dropdown-link">
          {{ fullName }}<i class="el-icon-caret-bottom el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <el-button
              size="mini"
              type="text"
              style="right: 20px; float: right"
              @click="setInfo"
              >资料编辑</el-button
            >
          </el-dropdown-item>
          <el-dropdown-item>
            <el-button
              size="mini"
              type="text"
              style="right: 20px; float: right"
              @click="resetPass"
              >修改密码</el-button
            >
          </el-dropdown-item>
          <el-dropdown-item>
            <el-button
              size="mini"
              type="text"
              style="right: 20px; float: right"
              @click="logout"
              >退出登录</el-button
            >
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!--      <li class="el-icon-user"></li>-->
      <el-badge
        :value="warnNum"
        :max="99"
        class="el-icon-warn"
        v-if="hasPerm('bjgl')"
      >
        <img
          :src="wIcon"
          style="height: 18px; cursor: pointer"
          @click="warnBtn"
          id="warnIcon"
        />
      </el-badge>
      <MySysNotice class="el-icon-horn"></MySysNotice>
    </div>
    <resetPassDialog :show.sync="resetPassDialogFormVisible"></resetPassDialog>
    <setInfoDialog
      :show.sync="setInfoDialogFormVisible"
      :defaultId="defaultId"
    ></setInfoDialog>
  </div>
</template>

<script>
import hasPerm from "../../javascript/hasPermJs";
import resetPassDialog from "../dialog/accountDialogDir/resetPassDialog";
import setInfoDialog from "../dialog/platformDialogDir/setInfoDialog";
import MySysNotice from "../dialog/sysNotice/mySysNotice";
export default {
  components: {
    MySysNotice,
    resetPassDialog,
    setInfoDialog
  },
  data() {
    return {
      defaultId: "",
      setInfoDialogFormVisible: false,
      resetPassDialogFormVisible: false,
      hasPerm: hasPerm,
      runCount: null,
      warnNum: null,
      socket: null,
      name: "辽宁北斗",
      wIcon: require("@/assets/images/warningIcon.png"),
      logoImg: require("@/assets/images/bdlogo.png"),
      // logoImg: require("@/assets/images/bdlogo.png"),
      fullName: JSON.parse(sessionStorage.getItem("userInfo")).fullName,
      username: JSON.parse(sessionStorage.getItem("userInfo")).username
    };
  },
  mounted() {
    this.watcher();

    const platformInfo = sessionStorage.getItem("platformInfo")
    if (platformInfo) {
      const pfi = JSON.parse(platformInfo)
      if (pfi.platformLogo) {
        this.logoImg = pfi.platformLogo
      }
      if (pfi.platformLogo) {
        this.name = pfi.platformTitle
      }
    }
    this.runCount = setInterval(this.watcher, "60000");
  },
  destroyed() {
    clearTimeout(this.runCount);
  },
  methods: {
    setInfo() {
      if (sessionStorage.getItem("platformInfo") !== null) {
        this.defaultId = JSON.parse(sessionStorage.getItem("platformInfo")).id;
      } else {
        this.defaultId = "new";
      }
      this.setInfoDialogFormVisible = true;
    },
    resetPass() {
      this.resetPassDialogFormVisible = true;
    },
    watcher() {
      if (hasPerm("bjgl")) {
        // this.$apijs.getCautionCount(this, '/locationbs/caution/getCautionCount')
        this.$apijs.getCautionCount(
          this,
          "/locationbs/alarmRecord/countAlarmRecord"
        );
      }
    },
    warnBtn() {
      if (this.$route.path !== "/expressway/warningPage") {
        this.$router.push("/expressway/warningPage");
      }
    },
    logout() {
      sessionStorage.clear();
      sessionStorage.clear();
      clearInterval(this.runCount);
      this.$router.push("/");
    }
  }
};
</script>

<style scoped>
/* .header {
  height: 64px;
  line-height: 64px;
  color: #333;
  border-bottom: 1px solid #f0f0f0;
  background-color: #fff;
} */
.logoimg {
  display: inline-block;
  height: 44px;
  /* margin-top: -10px; */
  padding-left: 20px;
  /* position: absolute; */
  /* padding-top: 8px; */
  vertical-align: middle;
}
#title {
  display: inline-block;
  font-size: 24px;
  line-height: 44px;
  letter-spacing: 0.4px;
  vertical-align: middle;
}
.el-icon-user {
  width: 22px;
  height: 28px;
  line-height: 64px;
  float: right;
  margin-right: 1%;
}
.el-icon-warn {
  margin-top: 15px;
  line-height: 40px;
  float: right;
  margin-right: 2%;
}
.el-icon-horn {
  margin-top: 13px;
  line-height: 40px;
  float: right;
  margin-right: 2%;
}
.userControlClass {
  margin-right: 3.7%;
  line-height: 64px;
  float: right;
}
.el-dropdown-link {
  font-size: 16px;
  cursor: pointer;
}
.ifWarn {
  -webkit-animation: twinkling 1s infinite ease-in-out;
}
.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
@-webkit-keyframes twinkling {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0.2;
  }
}
@keyframes twinkling {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0.2;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/header.vue